import { ListNames } from "../../Enums/ChoiceEnums";
import { getObject, postObject } from "../ChoiceApi";
import { IntDatabaseIdAndNameModel } from "../Models/IntDatabaseIdAndNameModel";
import { IListByName, ISearchUserGroupInputs, ISearchUserGroupResults } from "../Models/SearchModel";

export async function searchUserScreenGroup(payload: ISearchUserGroupInputs): Promise<ISearchUserGroupResults | undefined> {
    return await postObject("api/List/SearchUserScreenGroup", payload);
}

export async function getListByName(listName: ListNames): Promise<IListByName | undefined> {
    return await getObject(`api/List/${listName}`);
}

export async function getAllUsersAndGroups(): Promise<IntDatabaseIdAndNameModel[] | undefined> {
    return await getObject("api/List/AllUsersAndGroups");
} 

export async function getAllUserIds(): Promise<IUserIdListItemModel[] | undefined> {
    return await getObject("api/List/AllUserIds");
}

export async function getGeographicalStates(): Promise<IGeographicalStateOrProvinceModel[] | undefined> {
    return await getObject("api/List/GeographicalStatesAndProvinces");
}   

export async function getRelationships_ResponsibleParty(): Promise<IListItem[]|undefined>{
    return getObject("api/List/Relationships/ResponsibleParty");
}

export async function getTimeOfDay_ChronicCareManagement(): Promise<IListItem[]|undefined>{
    return getObject("api/List/ChronicCareManagement/TimeOfDay");
}

export async function chronicCareManagement_NewsLetterDeliveryMethods(): Promise<IListItem[]|undefined>{
    return getObject("api/List/ChronicCareManagement/NewsLetterDeliveryMethods");
}

export async function nyPreschoolBilling_CPSEDistricts(): Promise<IListItem[]|undefined>{
    return getObject("api/List/NYPreschoolBilling/CPSEDistricts");
}

export async function paymentReceiptPreference_ReceiptCommunication(): Promise<IListItem[]|undefined>{
    return getObject("api/List/PaymentReceiptPreference/ReceiptCommunication");
}
export interface IUserIdListItemModel
{
    users_id: string,
    security_users_id: number,
    company: string,
    active: boolean,
    userText: string
}

export interface IGeographicalStateOrProvinceModel
{
    state_code: string,
    state_name: string,
    country_code: string,
    is_special_government_address: boolean,
    is_territory: boolean
}

export interface IListItem
{
    id: string,
    displayText: string,
    isHeader: boolean,
    data?: object
}

// export interface SearchResult<TItems>
// {
//     totalMatches: number,
//     results: TItems[]
// }

// export interface ICounty
// {
//     countyFIPS: string,
//     countyName: string,
//     stateName: string
// }